import { Controller } from "@hotwired/stimulus"
import { smartMatch } from "../../utils/smart_search"

export default class extends Controller {
  static targets = [
    "scopeOption",
    "selectionSection",
    "searchInput",
    "classroomFilter",
    "statusFilter",
    "transferFilter",
    "studentsTableBody",
    "studentRow",
    "studentCheckbox",
    "selectAllCheckbox",
    "selectedCount"
  ]

  connect() {
    this.defaultYear = this.parseNumberValue(this.element.dataset.schoolReportsFormDefaultYearValue)
    this.trimesterCounts = this.parseJSONValue(this.element.dataset.schoolReportsFormTrimesterCountsValue, {})
    this.statusLabels = this.parseJSONValue(this.element.dataset.schoolReportsFormStatusLabelsValue, {})
    this.initialScope = this.element.dataset.schoolReportsFormInitialScopeValue || 'multiple_students'

    this.setScope(this.initialScope)
    this.updateSelection()
  }

  showSection(scope) {
    // Cacher toutes les sections
    if (this.hasSelectionSectionTarget) {
      this.selectionSectionTargets.forEach(section => {
        const sectionScope = section.dataset.scope
        if (sectionScope === scope) {
          section.classList.remove('hidden')
        } else {
          section.classList.add('hidden')
        }
      })
    }
  }

  changeScope(event) {
    const scope = event.target.value
    this.setScope(scope)
  }

  filterStudents() {
    const searchTerm = this.hasSearchInputTarget ? this.searchInputTarget.value : ''
    const classroomFilter = this.hasClassroomFilterTarget ? this.classroomFilterTarget.value : ''
    const statusFilter = this.hasStatusFilterTarget ? this.statusFilterTarget.value : ''
    const transferFilter = this.hasTransferFilterTarget ? this.transferFilterTarget.value : ''

    this.studentRowTargets.forEach(row => {
      const studentName = row.querySelector('td:nth-child(2)')?.textContent || ''
      const classroomId = row.dataset.classroomId || ''
      const status = row.dataset.status || ''
      const transfers = row.dataset.transfers || ''

      let visible = true

      // Filtre par recherche
      if (!smartMatch(studentName, searchTerm)) {
        visible = false
      }

      // Filtre par classe
      if (classroomFilter && classroomId !== classroomFilter) {
        visible = false
      }

      // Filtre par statut
      if (statusFilter && status !== statusFilter) {
        visible = false
      }

      // Filtre par transfert
      if (transferFilter) {
        if (transferFilter === 'none' && transfers !== '0') {
          visible = false
        } else if (transferFilter === '1' && transfers !== '1') {
          visible = false
        } else if (transferFilter === '2+' && parseInt(transfers) < 2) {
          visible = false
        }
      }

      row.style.display = visible ? '' : 'none'
    })

    this.updateSelection()
  }

  toggleSelectAll(event) {
    const checked = event.target.checked
    
    this.studentCheckboxTargets.forEach(checkbox => {
      const row = checkbox.closest('tr')
      if (row && row.style.display !== 'none') {
        checkbox.checked = checked
      }
    })

    this.updateSelection()
  }

  updateSelection() {
    if (!this.hasStudentCheckboxTarget) return

    const checkedCount = this.studentCheckboxTargets.filter(cb => cb.checked).length
    
    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = checkedCount
    }

    // Mettre à jour l'état de la case "Tout sélectionner"
    if (this.hasSelectAllCheckboxTarget) {
      const visibleCheckboxes = this.studentCheckboxTargets.filter(cb => {
        const row = cb.closest('tr')
        return row && row.style.display !== 'none'
      })
      
      const allChecked = visibleCheckboxes.length > 0 && 
                        visibleCheckboxes.every(cb => cb.checked)
      
      this.selectAllCheckboxTarget.checked = allChecked
    }
  }

  parseJSONValue(value, fallback = {}) {
    if (!value || typeof value !== 'string') return fallback

    try {
      return JSON.parse(value)
    } catch (error) {
      console.warn('Unable to parse JSON value', value, error)
      return fallback
    }
  }

  parseNumberValue(value) {
    if (value === undefined || value === null || value === '') return undefined
    const parsed = Number(value)
    return Number.isNaN(parsed) ? undefined : parsed
  }

  setScope(scope) {
    if (this.hasScopeOptionTarget) {
      this.scopeOptionTargets.forEach(option => {
        const input = option.querySelector('input[type="radio"]')
        if (input) {
          input.checked = input.value === scope
        }
      })
    }

    this.showSection(scope)
  }
}
